module.exports = __webpack_public_path__ + "static/media/email-icon.d82734d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Login/email-icon.svg
// module id = 113
// module chunks = 0